import React, { useCallback, useState } from 'react';
import WorkflowPopupNotificationContext from './WorkflowPopupNotification.context';
import useCountdown from 'router/subrouters/Auth/hooks/useCountdown';
import FloatingBanner from 'components/FloatingBanner';
import { useTranslation } from 'react-i18next';
import { FLOATING_BANBER_COLORS } from 'components/FloatingBanner/FloatingBanner.component';
import { POSITION } from 'models/Position';

const POPUP_TIMEOUT = 3;

type WorkflowPopupNotificationProps = Record<string, any>;

const WorkflowPopupNotification: React.FC<WorkflowPopupNotificationProps> = (
  props,
) => {
  const { children } = props;

  const [changedFieldId, setChangedFieldId] = useState<string | null>(null);

  const { timeLeft, startCountdown, clearCountdown } =
    useCountdown(POPUP_TIMEOUT);

  const { t } = useTranslation();

  const setField = useCallback(
    (field: string) => {
      clearCountdown();
      setChangedFieldId(field);
    },
    [clearCountdown],
  );

  return (
    <WorkflowPopupNotificationContext.Provider
      value={{ setField, startCountdown }}
    >
      {children}

      {!!timeLeft && (
        <FloatingBanner
          className="worfklow-floating-banner"
          color={FLOATING_BANBER_COLORS.BLACK}
          selector={`[id="${changedFieldId}"]`}
          preferredPosition={POSITION.RIGHT}
          showBannerNotification
          hasCloseButton={false}
        >
          {t('updated')}
        </FloatingBanner>
      )}
    </WorkflowPopupNotificationContext.Provider>
  );
};

export default WorkflowPopupNotification;
